import React from 'react';

export const PeopleIcon = props => (
  <svg viewBox="0 0 22 19" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none">
      <path d="M8.914 18.083h7.503s0-2.793-.395-3.984c-.344-1.036-2.83-1.729-5.439-2.712V9.303s.834-.516.834-2.5c.833 0 .833-1.666 0-1.666 0-.195.898-1.399.625-2.5-.395-1.587-5.126-1.587-5.521 0-1.974-.397-.938 2.233-.938 2.5v1.666c0 1.984 1.667 2.5 1.667 2.5v2.084c-2.315.879-5.095 1.676-5.438 2.712-.395 1.191-.395 3.984-.395 3.984h7.497z" />
      <path d="M18.5 18.083h2.083s0-2.793-.395-3.984c-.344-1.036-2.83-2.146-5.438-3.129V9.72s.833-.516.833-2.5c.834 0 .834-1.667 0-1.667 0-.195.899-1.551.625-2.653-.185-.742-1.77-1.915-3.02-1.082" />
    </g>
  </svg>
);
